import { Button } from '@/components/ui/button'
import { Sheet, SheetContent, SheetTitle, SheetTrigger } from '@/components/ui/sheet'
import type { Conversation } from '@/types/chat'
import { Menu } from 'lucide-react'

import SidebarContent from './SidebarContent'

interface ConversationSidebarProps {
  conversations: Conversation[]
  isLoading: boolean
}

export default function ConversationSidebar(props: ConversationSidebarProps) {
  return (
    <>
      {/* Desktop sidebar */}
      <aside className="hidden w-72 shrink-0 border-r bg-background md:block">
        <SidebarContent {...props} />
      </aside>

      {/* Mobile sheet */}
      <div className="md:hidden">
        <Sheet>
          <SheetTrigger asChild>
            <Button variant="ghost" size="icon" className="absolute left-3 top-3 z-10">
              <Menu className="h-5 w-5" />
            </Button>
          </SheetTrigger>
          <SheetContent side="left" className="w-72 p-0">
            <SheetTitle className="sr-only">Conversations</SheetTitle>
            <SidebarContent {...props} />
          </SheetContent>
        </Sheet>
      </div>
    </>
  )
}
